/** Columns of the downloadable template; the wizard maps them automatically (CT-5635). */
export const IMPORT_TEMPLATE_COLUMNS = Object.freeze([
  'First name',
  'Last name',
  'Email',
  'Job title',
  'Role',
  'Group',
]);

const EXAMPLE_ROW = ['Ana', 'Lopez', 'ana.lopez@example.com', 'Data Analyst'];

const quote = (cell) => (/[",\n\r;]/.test(cell) ? `"${cell.replace(/"/g, '""')}"` : cell);
const line = (cells) => cells.map(quote).join(',');

/**
 * CSV template that lists the workspace roles and groups above the column names, so the names
 * people type match. Row 1 = roles, row 2 = groups, row 3 = column names, row 4 = an example.
 *
 * @param {{ roles: string[], groups: string[] }} lists
 * @returns {string}
 */
export function buildImportTemplate({ roles, groups }) {
  const rows = [
    ['Roles you can use', roles.join(' | ')],
    ['Groups you can use', groups.join(' | ')],
    [...IMPORT_TEMPLATE_COLUMNS],
    [...EXAMPLE_ROW, roles[0] ?? '', groups[0] ?? ''],
  ];
  // The BOM makes Excel read accented role / group names as UTF-8; the CSV parser strips it.
  return `\uFEFF${rows.map(line).join('\r\n')}\r\n`;
}
